// Tunable parameters for the premium WebGL foil shader. Each key maps to a
// `u<Key>` float uniform in foilShader.js. Toggles are stored as 0/1 so they
// drop straight into the shader as multipliers.

export const DEFAULT_FOIL_PARAMS = {
  // Parallax / relief
  pomOn: 1, pomDepth: 0.017, reliefStrength: 1.3, normalBlur: 0.0,
  // Depth-driven sheen (no art displacement): the baked depth map feeds the
  // foil's relief normal + holo slide so the shine wraps the subject's real 3D
  // form and the holographic layer parallaxes above the surface.
  //   depthReliefStrength = how strongly depth sculpts the lighting normal.
  //   depthShine          = how far the holo layer slides per unit depth on tilt.
  depthReliefStrength: 1.5, depthShine: 0.6,
  // Environment reflection (metal)
  envOn: 1, envStr: 0.7, metalTint: 0.3,
  matcapOn: 1, matcapRot: 0.0,
  // GGX specular
  ggxOn: 1, ggxStr: 1.3, rough: 0.3,
  // Iridescence
  iridOn: 1, iridStr: 0.6, iridTint: 0.4, hueShift: 0.7, deckRamp: 0,
  thinFilmOn: 1, filmThickness: 350, filmIor: 1.5,
  // Sparkle
  sparkleOn: 1, sparkleStr: 1.3, sparkleDensity: 7.0, sparkleThresh: 0.55,
  // Microfacet glint (multiscale, half-vector driven)
  glintOn: 1, glintDensity: 150.0, glintSharp: 12.0, glintSpread: 0.8, glintBrightness: 1.6,
  // Emboss (zone bevel)
  embossOn: 1, embossStr: 0.8,
  // Global
  shineLo: 0.30, shineHi: 0.85, restFloor: 0.5, shadowStr: 0.56,
  // Per-card foil MODE is classified in the bake (generate-foil-maps.js) and
  // stored in foilmap.b: LIGHT / DARK / COLOUR. The shader runs one rule per
  // card; these tune each rule's LOOK (classification thresholds live in the bake):
  //   DARK: foil only the near-black tail (luma < darkShineLo = full, > darkShineHi = none).
  darkShineLo: 0.0, darkShineHi: 0.12,
  //   COLOUR: foil the most SATURATED/vivid regions (the strongest colour).
  //   colorThresh = the saturation a pixel needs before it foils (raise to foil
  //   only the most vivid areas, lower to include more muted colour).
  colorThresh: 0.25,
  // Resting light source position (tilt adds to this); 0,0 = straight on
  restLightX: -0.15, restLightY: -0.2,
  // Always-on rest signature (recognisable as foil even flat): a static holo
  // sheen on the light areas + a colored glow halo around the card.
  restHolo: 0.18, glowStr: 0.4,
};

export function paramUniformName(key) {
  return 'u' + key[0].toUpperCase() + key.slice(1);
}
